module.exports = __webpack_public_path__ + "html/feedback-slider_e20c5e7655d89387dbdf6c645e43e11a.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/feedback-slider.html
// module id = Zm8k
// module chunks = 4